import { connect } from "react-redux";
import ViewMeta from "../quiz/ViewMeta";

const mapStateToProps = state => ({
  meta: state.quiz2.meta
});

export default connect(mapStateToProps)(ViewMeta);
